/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'system';
const componentName = 'system-settings-modal';
const prefix = `${moduleName}.${componentName}`;

export const headerLabel = `${prefix}.headerLabel`;
export const sectionTitleDnsServices = `${prefix}.sectionTitleDnsServices`;
export const sectionSyslog = `${prefix}.sectionSyslog`;
export const controllerLabel = `${prefix}.controllerLabel`;
export const sectionTitleEmailSmtp = `${prefix}.sectionTitleEmailSmtp`;
export const sectionTitleDnsNtp = `${prefix}.sectionTitleDnsNtp`;
export const sectionTitleAccess = `${prefix}.sectionTitleAccess`;

export const ENGLISH = {
    [headerLabel]: 'Edit System Settings',
    [sectionTitleDnsServices]: 'DNS Services',
    [sectionSyslog]: 'Syslog',
    [controllerLabel]: 'Controller',
    [sectionTitleEmailSmtp]: 'Email/SMTP',
    [sectionTitleDnsNtp]: 'DNS/NTP',
    [sectionTitleAccess]: 'Access',
};
